export const TYPE_STRENGTHS_AND_WEAKNESSES = 'strengths-and-weaknesses';
export const TYPE_TEXT_ASSET = 'text-asset';
export const TYPE_ASSET_TEXT = 'asset-text';
export const TYPE_PICTURE = 'picture';
export const TYPE_VIDEO = 'video';
export const TYPE_YOUTUBE_VIDEO = 'youtube video';

export const METADATA_SOURCE = 'source';
export const METADATA_SOURCE_VALUE_ADMIN = 'colizey-admin';
